// Client requests
export const CLIENT_LIST = "CLIENT_LIST";
export const CLIENT_CREATE = "CLIENT_CREATE";
export const CLIENT_FILTER = "CLIENT_FILTER";
export const CLIENT_UPDATE = "CLIENT_UPDATE";

// Client success
export const CLIENT_LIST_SUCCESS = "CLIENT_LIST_SUCCESS";
export const CLIENT_CREATE_SUCCESS = "CLIENT_CREATE_SUCCESS";
export const CLIENT_UPDATE_SUCCESS = "CLIENT_UPDATE_SUCCESS";

// Client failed
export const CLIENT_REQUEST_FAILED = "CLIENT_REQUEST_FAILED";
